(function() {
    'use strict';

    // 花火アニメーションの作成
    function createFireworkAnimation(checkboxElement) {
        const rect = checkboxElement.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.height / 2;
        
        // コンテナ作成
        const container = document.createElement('div');
        container.className = 'firework-container';
        container.style.position = 'fixed';
        container.style.pointerEvents = 'none';
        container.style.left = '0';
        container.style.top = '0';
        container.style.width = '100%';
        container.style.height = '100%';
        container.style.zIndex = '9999';
        document.body.appendChild(container);
        
        // 花火のパーティクルを作成
        const particleCount = 12;
        for (let i = 0; i < particleCount; i++) {
            const particle = document.createElement('div');
            particle.className = 'firework-particle';
            particle.style.position = 'absolute';
            particle.style.left = centerX + 'px';
            particle.style.top = centerY + 'px';
            particle.style.width = '6px';
            particle.style.height = '6px';
            particle.style.borderRadius = '50%';
            
            // カラフルな色をランダムに
            const colors = ['#FFD700', '#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8', '#F7DC6F'];
            particle.style.background = colors[Math.floor(Math.random() * colors.length)];
            
            const angle = (360 / particleCount) * i;
            particle.style.setProperty('--angle', angle + 'deg');
            particle.style.animation = 'particleExplosion 0.8s ease-out forwards';
            
            container.appendChild(particle);
        }
        
        // アニメーション後にコンテナを削除
        setTimeout(() => {
            container.remove();
        }, 800);
    }
    
    // CSSアニメーションを動的に追加
    const style = document.createElement('style');
    style.textContent = `
        @keyframes particleExplosion {
            0% {
                transform: translate(-50%, -50%) rotate(var(--angle)) translateY(0) scale(1);
                opacity: 1;
            }
            50% {
                opacity: 1;
            }
            100% {
                transform: translate(-50%, -50%) rotate(var(--angle)) translateY(-50px) scale(0);
                opacity: 0;
            }
        }
        
        @keyframes checkboxBounce {
            0% {
                transform: scale(1) rotate(0deg);
            }
            25% {
                transform: scale(1.3) rotate(-5deg);
            }
            50% {
                transform: scale(1.15) rotate(5deg);
            }
            65% {
                transform: scale(1.25) rotate(-3deg);
            }
            80% {
                transform: scale(1.05) rotate(2deg);
            }
            100% {
                transform: scale(1.2) rotate(0deg);
            }
        }
        
        .checkbox.checked {
            animation: checkboxBounce 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55) forwards;
        }
    `;
    document.head.appendChild(style);
    
    // DOMロード後にイベントリスナーを設定
    function initCheckboxAnimation() {
        // .filter-content内のすべてのチェックボックスを取得
        const filterContents = document.querySelectorAll('.filter-content');
        
        filterContents.forEach(filterContent => {
            const checkboxInputs = filterContent.querySelectorAll('input[type="checkbox"]');
            
            checkboxInputs.forEach(input => {
                input.addEventListener('change', function() {
                    // 親のlabelから.checkboxを見つける
                    const label = this.closest('label');
                    if (label) {
                        const checkboxDiv = label.querySelector('.checkbox');
                        if (checkboxDiv) {
                            if (this.checked) {
                                // チェックされたときの処理
                                checkboxDiv.classList.add('checked');
                                createFireworkAnimation(checkboxDiv);
                            } else {
                                // チェックが外されたときの処理
                                checkboxDiv.classList.remove('checked');
                            }
                        }
                    }
                });
            });
        });
    }
    
    // DOMが完全にロードされた後に実行
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initCheckboxAnimation);
    } else {
        initCheckboxAnimation();
    }
    
})();
